import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { AddlinkConstant } from '../../../../constants/addlinkConstants';
import { SharedConstant, SharedService } from '@ems/shared';
import { RequestListService } from '../../../services/request-list.service';
import {
  CommunicationService
  , IChannelContract, IFileDataContract, IFileRemoveContract,
  IFileUploadResultContract, Env, IRehydrateContract, IErrorDisplayContract, IFileTooltip
} from '@schwab/safeui';
import { Subject, take } from 'rxjs';
import { UUID } from 'angular2-uuid';

@Component({
  selector: 'addlink-upload-loa-modal',
  templateUrl: './upload-loa-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class UploadLOAModalComponent implements OnInit, OnDestroy {
  @Input() modalData: any;
  @Output() closeEvent = new EventEmitter<string>();
  channelDetails: IChannelContract;
  filesResult: IFileUploadResultContract[] = [];
  filesRemoved: IFileRemoveContract[] = [];
  reHydrateData: IRehydrateContract;
  errorDisplay: IErrorDisplayContract;
  tooltipConfig: IFileTooltip;
  overrideWidgetErrors = true;
  addLinkConstant = AddlinkConstant;
  showError = false;
  showUploadError = false;
  private _modalCloseInProgress = false;
  public title = '';
  public requestIds: any[];
  orgId: any;
  errorMessage: string;
  uploadErrorFileMsg: string;
  uuidValue: any;
  sharedConstant = SharedConstant;

  constructor(public sharedService: SharedService, public requestListService: RequestListService, public commService: CommunicationService,) {
    this.uuidValue = UUID.UUID();
  }
  /* Initialize component variables */
  ngOnInit() {
    this.title = this.modalData.title;
    this.requestIds = this.modalData.requestIds;
    this.orgId = this.modalData.orgId;
    this.requestIds.sort();
    this.requestIds.reverse();
    this.sharedService.openModal('beta-upload-LOA-request-modal');
    this.setSafeContract();
    this.commService.browseEvent$ = new Subject<IFileDataContract>();
    this.commService.fileRemove$ = new Subject<IFileRemoveContract>();
    this.commService.browseEvent$.subscribe(fileData => this.handleFileBrowse(fileData));
    this.commService.fileRemove$.subscribe(res => this.handleFileRemove(res));
  }

  checkErrors(file: IFileUploadResultContract) {
    if (file.errorMsg !== null) {
      this.showError = true;
      this.errorMessage = file.errorMsg.toLowerCase().includes('file size')
        ? this.sharedConstant.bulkUpload.uploadLOATErrorMessageFileSize
        : file.errorMsg;
    }
  }

  setFileMetadata(fileData: IFileDataContract) {
    fileData.fileMetadata.fileArtifactType = 'LOA';
    fileData.securityToken = `Bearer ${localStorage.getItem('token')}`;
    fileData.displayFileSize = false;
    this.commService.pubishFileMetadata(fileData);
  }

  handleFileBrowse(fileData: IFileDataContract): void {
    this.sharedService.safeUpload = true;
    this.setFileMetadata(fileData);
    if (this.reHydrateData === undefined) {
      this.reHydrateData = {} as IRehydrateContract;
      this.reHydrateData.token = `Bearer ${localStorage.getItem('token')}`;
    }
    this.commService.fileUploadResult$.pipe(take(1)).subscribe((result: IFileUploadResultContract) => {
      // result is a IFileUploadResultContract which provides the file upload success, failure and error details.
      //Read Rehydration Data from Response
      if ((this.reHydrateData !== undefined && this.reHydrateData.files === undefined) || this.showError) {
        this.reHydrateData.files = [];
      }
      if (this.reHydrateData !== undefined && this.reHydrateData.files !== undefined) {
        this.reHydrateData.files.push(result.fileRehydrateContract);
      }
      this.showError = false;
      this.showUploadError = false;
      this.uploadErrorFileMsg = '';
      this.errorMessage = '';
      if (this.overrideWidgetErrors) {
        this.checkErrors(result);
      }
      this.filesResult.push(result);
      this.errorDisplay = {
        showBannerError: true,
        showInlineError: false
      };
      if (result.errorMsg === null) {
        this.sharedService.safeUpload = false;
        this.uploadFile();
      }
    });
  }

  handleFileRemove(res: IFileRemoveContract): void {
    if (res.safeId && res.isRemoved) {
      this.reHydrateData.files.length = 0;
      this.reHydrateData = {} as IRehydrateContract;
      this.filesResult.length = 0;
      this.sharedService.clearErrorMessage();
      this.showError = false;
      this.showUploadError = false;
      this.uploadErrorFileMsg = '';
    }
  }

  setSafeContract(): void {
    this.channelDetails = {
      clientAppId: 'AD00006551',
      clientCorrelId: this.uuidValue,
      env: Env[this.sharedService.domainValue as keyof typeof Env],
      configureLinks: {
        showRemoveFileLink: false
      }
    };

    this.errorDisplay = {
      showBannerError: true,
      showInlineError: false
    };
  }

  uploadFile() {
    const reqPayload = {
      operation: 'UPLOAD_LOA',
      index: '',
      requestIds: this.requestIds,
      safeId: this.reHydrateData.files.map(a => a.safeId).toString(),
    }
    this.requestListService.uploadOrApproveOrDeclineLOA(reqPayload, this.orgId).subscribe({
      next: (response: any) => {
        this.uploadErrorFileMsg = '';
        this.closeModal('success');
      },
      error: (error) => {
        this.showUploadError = true;
        this.uploadErrorFileMsg = error?.message || 'An error occurred during file upload. Please try again.';
      },
      complete: () => {
        // Handle completion
      }
    });
  }

  closeModal(message?: string): void {
    // Guard against re-entrant close calls: sharedService.closeModal() can
    // trigger the modal close event, which may call closeModal() again on
    // the same instance. This latch ensures emit/close runs only once.
    if (this._modalCloseInProgress) { return; }
    this._modalCloseInProgress = true;
    this.showError = false;
    this.closeEvent.emit(message || 'closed');
    this.sharedService.closeModal('beta-upload-LOA-request-modal');
  }

  ngOnDestroy() {
    this.commService.fileRemove$.complete();
    this.commService.browseEvent$.complete();
    this.sharedService.disableClientSelector.next(this.sharedService.ClientCount === this.sharedConstant.clientCount);
  }
}
